module.exports = __webpack_public_path__ + "img/YKM_common.f4e2ec73.png";